import BaseModel from "@/lib/models/BaseModel";

export default class PriceUpdate extends BaseModel {
    private _id: string = "";
    private _price: number = 0;
    private _note: string = "";
    private _date: Date | string = new Date();


    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }

    get note(): string {
        return this._note;
    }

    set note(value: string) {
        this._note = value;
    }

    get date(): Date | string {
        return this._date;
    }

    set date(value: Date | string) {
        this._date = value;
    }
}
